import { Badge, Button, Divider, Modal, Popover, Select, Space, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useShItems } from './ShItemsStore';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

function ShopProducts(props) {
    let [open, setOpen] = useState(false)
    let [prns, setPrns] = useState([])
    let [trshop, setTrshop] = useState(0)
    let [rend, setRend] = useState(false)
    let [shdata, setShdata] = useState([])
    let { data, getVitrina, columns, shops, getShops, transfers, getTransfer } = useShItems();
    useEffect(() => {
        getVitrina()
        getShops()
        getTransfer()
    }, [getShops, getTransfer, getVitrina])

    useEffect(() => {
        setShdata(data)
    }, [data])

    let handleData = (v) => {
        if(v === "Xammasi"){
            setShdata(data)
        }else{
            setShdata(data.filter(d=> d.shopid === v))
        }
    }
    let handlePrns = (v) => {
        setTrshop(v)
        setPrns(transfers.filter(t => t.respondent_in === v))
    }


    return (
        <div>
            <Modal title={"Perenos tovarlarni qabul qilish"} width={800} footer={null} onCancel={() => setOpen(false)} open={open}>
                <p>Oldin magazinni tanlang</p>
                <Select size='large' onChange={(v) => handlePrns(v)} style={{ width: '700px' }} defaultValue={'all'} options={[{ value: 'all', label: "Xammasi" }, ...shops.map(sh => ({ label: sh.shopname, value: sh.id }))]} />
                <Divider />
                <Table
                    columns={[
                        { dataIndex: 'id', dataSource: 'id', title: 'ID' },
                        {
                            dataIndex: 'id', dataSource: 'id', title: 'Maxsulot', render: (_, rec) => {
                                return (
                                    <>
                                        <p>{rec.nameuz}</p>
                                        <p>{rec.country} {rec.manufacturer}</p>
                                        <p>{rec.catname}</p>
                                    </>
                                )
                            }
                        },
                        { dataIndex: 'count', dataSource: 'count', title: 'Soni', align: 'right' },
                        {
                            dataIndex: 'id', dataSource: 'id', title: 'Qabul qilish', align: 'right', render: (_, rec) => (<Space>
                                <Popover title="Ishonchingiz komilmi?" trigger={'click'} content={<Button onClick={()=>{
                                    let dt = {shop_id: trshop, vr_id: rec.vr_id, count: rec.count, prnsid: rec.id}
                                    axios.post('checktran', dt).then(res=> setRend(!rend))
                                }} type='default'>Tasdiqlash</Button>}>
                                    <Button type='primary'><CheckCircleOutlined /></Button>
                                </Popover>
                                <Popover trigger={'click'} content={<Button type='default'>Tasdiqlash</Button>} title="Ishonchingiz komilmi?">
                                    <Button type='primary' danger><CloseCircleOutlined /></Button>
                                </Popover>
                            </Space>)
                        },
                    ]}
                    dataSource={prns}
                    rowKey={'id'}
                />
            </Modal>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                <h4>Magazinlar maxsulotlari</h4>
                <Select onChange={(v)=>handleData(v)} style={{ width: '300px' }} defaultValue={'Xammasi'} options={[{ key: null, value: "Xammasi" }, ...shops.map(sh => ({ label: sh.shopname, value: sh.id }))]} />
                <Badge count={transfers.length}><Button onClick={() => setOpen(true)} disabled={transfers.length === 0} type='primary'>Qabul qilish</Button></Badge>
            </div>
            <Table
                columns={columns}
                dataSource={shdata}
                rowKey={'id'}
            />
        </div >
    );
}

export default ShopProducts;